import PropTypes from 'prop-types';

import Link from '@zenbusiness/zui/Link';

import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

/**
 * Component that renders a anchor link to reference a note in the footnote section.
 * @param {object} props - The component props.
 * @param {Array<string>} props.chunks - Formatted message chunk to display in the link and the footnote ID to jump to.
 * @example
 * On messages.json file, you can use the following format:
 *   "message.id": "This is a message with a footnote <footnoteAnchorLink>*</footnoteAnchorLink>",
 * To render the following HTML:
 *   <p>This is a message with a footnote <sup><a href="#footnote-*">*</a></sup></p>
 * @component
 */
export function FootnoteAnchorLink({ chunks }) {
  const personalizationClickstreamProps = useProductLandingClickstreamProps();

  return (
    <sup>
      <Link
        clickstreamProps={{ ...personalizationClickstreamProps, elementName: 'footnote_link' }}
        href={`#footnote-${chunks}`}
        underline="hover"
      >
        {chunks}
      </Link>
    </sup>
  );
}

FootnoteAnchorLink.propTypes = {
  chunks: PropTypes.arrayOf(PropTypes.string).isRequired
};
